var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoThumbnail = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image_FILL0_wght400_GRAD0_opsz24",
    d: "M123.111-812a3,3,0,0,1-2.2-.914,3,3,0,0,1-.914-2.2v-21.778a3,3,0,0,1,.914-2.2,3,3,0,0,1,2.2-.914h21.778a3,3,0,0,1,2.2.914,3,3,0,0,1,.914,2.2v21.778a3,3,0,0,1-.914,2.2,3,3,0,0,1-2.2.914Zm0-3.111h21.778v-21.778H123.111Zm1.556-3.111h18.667L137.5-826l-4.667,6.222-3.5-4.667Zm-1.556,3.111v0Z",
    transform: "translate(-120 840)",
    fill: "#aeb4b9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoThumbnail);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICA8cGF0aCBpZD0iaW1hZ2VfRklMTDBfd2dodDQwMF9HUkFEMF9vcHN6MjQiIGQ9Ik0xMjMuMTExLTgxMmEzLDMsMCwwLDEtMi4yLS45MTQsMywzLDAsMCwxLS45MTQtMi4ydi0yMS43NzhhMywzLDAsMCwxLC45MTQtMi4yLDMsMywwLDAsMSwyLjItLjkxNGgyMS43NzhhMywzLDAsMCwxLDIuMi45MTQsMywzLDAsMCwxLC45MTQsMi4ydjIxLjc3OGEzLDMsMCwwLDEtLjkxNCwyLjIsMywzLDAsMCwxLTIuMi45MTRabTAtMy4xMTFoMjEuNzc4di0yMS43NzhIMTIzLjExMVptMS41NTYtMy4xMTFoMTguNjY3TDEzNy41LTgyNmwtNC42NjcsNi4yMjItMy41LTQuNjY3Wm0tMS41NTYsMy4xMTF2MFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjAgODQwKSIgZmlsbD0iI2FlYjRiOSIvPgo8L3N2Zz4K";